import FJFake3dPreview from '../FJFake3dPreview/FJFake3dPreview';
import { useSelector, useDispatch } from 'react-redux';
import FJFake3dCreation from './FJFake3dCreation';
import PropTypes from 'prop-types';
import FJActionFake3d from '../../../redux/action/FJActionFake3d';
import useLocalStore from '../../../hooks/useLocalStore';

const FJFake3dCreationContainer = ({ active }) => {
    useLocalStore();
    const dispatch = useDispatch();
    const deepMapImage = useSelector(state => state.fake3d.deepMapImage);
    const originImage = useSelector(state => state.fake3d.originImage);

    const hasDeepMapImage = deepMapImage && deepMapImage.src;
    const editPreset = (data, callback) => {
        dispatch(FJActionFake3d.editPresetAction(data, callback));
    };

    if (hasDeepMapImage) {
        return <FJFake3dCreation deepMapImage={deepMapImage} originImage={originImage} active={active} />;
    } else {
        return <FJFake3dPreview editPreset={editPreset} active={active} />;
    }
};

FJFake3dCreationContainer.propTypes = {
    active: PropTypes.bool,
};
export default FJFake3dCreationContainer;
